<!-- https://danielk.tech/home/angular-how-to-add-a-loading-spinner -->

<div class="h1 text-center ft-wght-300 font-oswald bg-dull text-gold py-md-5 m-0 py-4">Video Library</div>
<section class="video-library-form py-3 bg-white shadow position-relative">
  <div class="container">
    <div class="row video-library-form g-3">
      <div class="col-md-6 col-lg-3" data-aos="fade-left" data-aos-duration="1000">
        <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" class="selectpicker rules font-oswald w-100"
          (change)="allLevelsOfRule()" [(ngModel)]="rules">
          <option value="">Select Rule</option>
          <option *ngFor="let rule of rulesList" [value]="rule?.id">{{rule?.name}}</option>
        </select>
      </div>
      <div class="col-md-6 col-lg-3" data-aos="fade-left" data-aos-duration="1000">
        <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" class="selectpicker level font-oswald w-100"
          [(ngModel)]="levels" [disabled]="disableLevel" (change)="allCategories()">
          <option value="">Select Level</option>
          <option *ngFor="let level of levelsList" [value]="level?.id">{{level?.name | titlecase}}</option>
        </select>
      </div>
      <div class="col-md-6 col-lg-3" data-aos="fade-left" data-aos-duration="1000">
        <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300"
          class="selectpicker category font-oswald w-100" [(ngModel)]="category" [disabled]="disableCategory"
          (change)="allSkills()">
          <option value="">Select Category</option>
          <option *ngFor="let cat of categoryList" [value]="cat?.id">{{cat?.name | titlecase}}</option>
        </select>

      </div>
      <div class="col-md-6 col-lg-3" data-aos="fade-left" data-aos-duration="1000">
        <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300" title="Select Skills" multiple class="selectpicker skill font-oswald w-100"
          [(ngModel)]="skill" [disabled]="disableSkills">
          <option *ngFor="let skill of skillsList" [value]="skill?.id">{{skill?.name | titlecase}}</option>
        </select>
      </div>
    </div>
  </div>
  <!-- <hr class="mt-2 mb-1" *ngIf="attributeList"> -->

  <div class="container" *ngIf="attributeList">
    <div class="d-flex flex-lg-wrap search-attributes-div mt-3">  
      <div class="flex-fill mb-2" *ngFor="let item of attributeList" data-aos="fade-left" data-aos-duration="1000">
        <select data-style="rounded-pill px-4 py-2 select_box ft-wght-300"
          class="selectpicker attributes font-oswald w-100" [title]="toLower(item.name)" (change)="getAttributesVal($event,item.id)"
          [(ngModel)]="attri[item.name]">
          <option *ngFor="let choice of item.choices" [value]="choice.choice_id">{{choice.title}}</option>
        </select>
      </div>
    </div>
  </div>
  <!-- <hr class="mt-2 mb-1" *ngIf="attributeList"> -->
  <div class="container">
    <div class="row video-library-form g-3" data-aos="fade-in" data-aos-duration="1000">
      <div class="col-md-6 pe-md-4">
        <input class="form-control me-2" type="search" [(ngModel)]="keyword" placeholder="Search with Keyword" aria-label="Search">
      </div>
      <div class="col-md-6 ps-md-4">
        <button class="btn btn-lg btn-gold me-lg-4 me-2" type="submit" (click)="search()">Search</button>
        <button class="btn btn-lg btn-red ms-lg-4 ms-2 me-lg-4 me-2" (click)="resetSearch()" type="submit">Reset</button>
        <button class="btn btn-lg btn-gold ms-lg-4 ms-2" data-bs-toggle="modal" data-bs-target="#suggest-skill" href="javascript:void(0)">Suggest a Skill</button>
      </div>
    </div>
  </div>
</section>

<section class="video-library min-height" data-aos="fade-up" data-parallax="scroll"
data-image-src="../../assets/brand/star-image.png">
  <div class="container py-4">
    <div class="row" data-aos="fade-in" data-aos-duration="1000">
      <div class="col-12">
        <p class="text-center py-5" *ngIf="noVideos">Sorry, no videos found.</p>
      </div>
      <div class="col-md-6 col-lg-4 p-4" data-aos="fade-up" data-aos-duration="1000" *ngFor="let video of videosList">
        <div class="card shadow video-item {{video.allowed?'':'locked'}}" (click)="openDetails(video.id,'staticBackdrop')"> 
          <div class="card-img-overlay">
            <button type="button" class="btn btn-sm btn-gold float-start shadow">{{video.cat | uppercase}}</button>
            <i class="fa fa-heart float-end" [ngClass]="video.fav==1?'text-red':''" (click)="addToFav($event,video)"></i>
          </div>
          <div class="card-body">  
            <img class="rounded-3 w-100" src="{{this.getThumbUrl(video.video_thumb)}}">
            <h6 class="card-title mt-3 text-uppercase">{{video.name | uppercase}}</h6>
            <p class="card-text">{{showSmallDescription(video.description)}} ...</p>
            <span class="btn-dull me-2 mb-2 d-inline-block" *ngFor="let skill of video.skills">{{skill.name | uppercase}}</span>
          </div>
        </div>
      </div> 
 
    </div>

    <div class="text-center" *ngIf="totalvideo > videosList.length">
      <button class="btn btn-lg btn-gold me-4" (click)="showMore()">Load More</button>
    </div>
  </div>
</section>

<!-- Modal -->

<app-video-details modalid="staticBackdrop" [videoDetails]="videoDetails"></app-video-details>
<!-- 1 feb 10:30 wed -->